/* Afkar Plus - lucky spin popup (BeyondADS 24 Sep 2026; odds v2 15 Oct 2026) */
(function () {
  'use strict';
  if (window.__aswLoaded) return; window.__aswLoaded = true;
  var KEY = 'afkarSpin', WEEK = 7 * 864e5;
  /* odds per 100 spins, set by the client 15 Oct 2026: try again 45, free gift 37, 10% 15, free delivery 2, 15% 1.
     w is the chance for the PRIZE; when a prize sits in two slots it is split evenly between them (see pick). */
  var PRIZES = {
    again: { w: 45 },
    gift: { w: 37, title: 'Free gift', code: '', desc: 'Spend $35 or more and a free surprise gift is added to your bag automatically.', terms: 'Added at the cart once your bag reaches $35.' },
    p10:  { w: 15, title: '10% off', code: 'SPIN10', desc: '10% off your whole order.', terms: 'One use per customer.' },
    ship: { w: 2, title: 'Free delivery', code: 'SPINSHIP', desc: 'Free delivery on your next order.', terms: 'One use per customer.' },
    p15:  { w: 1, title: '15% off', code: 'SPIN15', desc: '15% off orders of $25 or more.', terms: 'One use per customer. Minimum order $25.', note: 'Applies once your bag reaches $25.' }
  };
  function store(v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(KEY) || 'null'); localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { return null; } }

  function init(root) {
    if (root.parentNode !== document.body) document.body.appendChild(root);
    var keys = []; try { keys = JSON.parse(document.querySelector('[data-asw-keys]').textContent); } catch (e) {}
    if (!keys.length) return;
    var count = {}; keys.forEach(function (k) { count[k] = (count[k] || 0) + 1; });
    var wheel = root.querySelector('[data-asw-wheel]');
    var slices = root.querySelectorAll('[data-asw-slice]'), labs = root.querySelectorAll('[data-asw-lab]');
    var spinBtn = root.querySelector('[data-asw-spin]');
    var spun = 0, turn = 0, busy = false;

    function mark(i) {
      Array.prototype.forEach.call(slices, function (s, k) { s.classList.toggle('is-win', k === i); });
      Array.prototype.forEach.call(labs, function (s, k) { s.classList.toggle('is-win', k === i); });
    }
    mark(0);
    /* "Try again" can only land on the first spin, so the extra spin always ends on a prize */
    function pick(allowAgain) {
      var pool = keys.map(function (k, i) { var p = PRIZES[k]; return { k: k, i: i, w: (!p || (k === 'again' && !allowAgain)) ? 0 : p.w / count[k] }; });
      var sum = pool.reduce(function (s, p) { return s + p.w; }, 0), r = Math.random() * sum;
      for (var n = 0; n < pool.length; n++) { r -= pool[n].w; if (r <= 0 && pool[n].w) return pool[n]; }
      for (var m = pool.length - 1; m >= 0; m--) { if (pool[m].w) return pool[m]; }
      return pool[0];
    }
    function open() { root.hidden = false; document.documentElement.style.overflow = 'hidden'; setTimeout(function () { spinBtn && spinBtn.focus(); }, 60); }
    function close() {
      root.hidden = true; document.documentElement.style.overflow = '';
      var s = store(); if (!s || !s.won) store({ t: Date.now(), dismissed: true });
    }
    function showWin(key) {
      var p = PRIZES[key];
      root.querySelector('[data-asw-view="intro"]').hidden = true;
      root.querySelector('[data-asw-view="win"]').hidden = false;
      root.querySelector('[data-asw-prize]').textContent = p.title;
      root.querySelector('[data-asw-desc]').textContent = p.desc;
      root.querySelector('[data-asw-terms]').textContent = p.terms;
      var box = root.querySelector('[data-asw-codebox]'), apply = root.querySelector('[data-asw-apply]');
      if (p.code) {
        box.hidden = false; root.querySelector('[data-asw-code]').textContent = p.code;
        apply.setAttribute('href', '/collections/all');
        root.querySelector('[data-asw-apply-t]').textContent = 'Shop now';
        root.querySelector('[data-asw-terms]').textContent = 'Saved in your cart for the next 15 minutes. ' + p.terms;
        document.dispatchEvent(new CustomEvent('afkar:spin:won', { detail: { code: p.code, prize: p.title, note: p.note || '' } }));
      } else {
        box.hidden = true; apply.setAttribute('href', '/collections/all'); root.querySelector('[data-asw-apply-t]').textContent = 'Start shopping';
      }
      store({ t: Date.now(), won: key, code: p.code || '' });
    }
    function spin() {
      if (busy) return; busy = true; spinBtn.disabled = true;
      var res = pick(spun === 0); spun++;
      var target = -res.i * 45, cur = ((turn % 360) + 360) % 360;
      var delta = ((target - cur) % 360 + 360) % 360;
      var jitter = (Math.random() * 24) - 12;
      turn = turn + 360 * 6 + delta + jitter;
      wheel.classList.add('is-spinning');
      wheel.style.setProperty('--spin', turn + 'deg');
      mark(-1);
      setTimeout(function () {
        busy = false; wheel.classList.remove('is-spinning'); mark(res.i);
        if (res.k === 'again') {
          spinBtn.disabled = false; spinBtn.firstChild.nodeValue = 'Spin again ';
          root.querySelector('.asw-sub').innerHTML = 'So close! You get<br>one more spin.';
          return;
        }
        var key = res.k;
        setTimeout(function () { showWin(key); }, 450);
      }, 5400);
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-asw-close]')) { e.preventDefault(); close(); return; }
      if (e.target.closest('[data-asw-spin]')) { e.preventDefault(); spin(); return; }
      var cp = e.target.closest('[data-asw-copy]');
      if (cp) {
        var code = root.querySelector('[data-asw-code]').textContent;
        (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(function () { cp.textContent = 'Copied'; }, function () { cp.textContent = code; });
        setTimeout(function () { cp.textContent = 'Copy'; }, 1800);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

    var force = /[?&]afkar_spin=1/.test(location.search);
    var s = store();
    var recent = s && s.t && (Date.now() - s.t < WEEK);
    var blocked = /^\/(cart|checkout|checkouts|account)/.test(location.pathname);
    /* phones: never cover the page on arrival - a small side tab invites the spin, the shopper opens it when they want */
    var phone = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var tab = null;
    function hideTab(forever) { if (tab) { tab.classList.remove('is-in'); setTimeout(function () { if (tab) tab.hidden = true; }, 350); } if (forever) store({ t: Date.now(), dismissed: true }); }
    function showTab() {
      if (tab) return;
      tab = document.createElement('div'); tab.className = 'asw-tab'; tab.setAttribute('role', 'region'); tab.setAttribute('aria-label', 'Lucky spin');
      tab.innerHTML = '<button type="button" class="asw-tab__go" data-asw-tab-open><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-1.5-3-5-3.5-5-1.2C7 7.2 9.5 7 12 7zm0 0c1.5-3 5-3.5 5-1.2C17 7.2 14.5 7 12 7z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg><span>Spin &amp; win</span></button>' +
        '<button type="button" class="asw-tab__x" data-asw-tab-x aria-label="Hide the lucky spin">&times;</button>';
      document.body.appendChild(tab);
      tab.addEventListener('click', function (e) {
        if (e.target.closest('[data-asw-tab-x]')) { hideTab(true); return; }
        if (e.target.closest('[data-asw-tab-open]')) { hideTab(false); open(); }
      });
      requestAnimationFrame(function () { tab.classList.add('is-in'); });
      setTimeout(function () { if (tab) tab.classList.add('is-in'); }, 60);
    }
    if (force) setTimeout(open, 400);
    else if (!recent && !blocked) { if (phone) setTimeout(showTab, 4000); else setTimeout(open, 4000); }
    root.__aswOpen = open;
    /* test hook: window.__aswPick(n) returns how often each prize comes up in n simulated first spins */
    window.__aswPick = function (n) { var t = {}; for (var j = 0; j < n; j++) { var r = pick(true).k; t[r] = (t[r] || 0) + 1; } return t; };
  }
  function boot() { var r = document.querySelector('[data-asw]'); if (r && !r.__asw) { r.__asw = true; init(r); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
